<template>
    <div>
        <div class="modal fade" id="GroupTypeModal" tabindex="-1"
        aria-labelledby="GroupTypeModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-md modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 id="GroupTypeModalLabel" class="font-weight-bold">{{ModalTitle}}{{GroupTypeName}}</h4>
                        <a type="button" data-bs-dismiss="modal"
                        aria-label="Close">
                            <i class="fa fa-times"></i>
                        </a>
                    </div>

                    <div class="modal-body">
                        <CCardBody>
                            <CRow>
                                <CCol sm="4">
                                    <label class="form-label font-weight-bold required">Nama</label>
                                    <label class="form-label font-weight-bold" style="float:right">:&nbsp;</label>
                                </CCol>
                                <CCol sm="8">
                                    <CInput id="GroupTypeName" v-model="GroupTypeName" class="font-weight-bold" />
                                    <label id="errorGroupTypeName" class="form-error" style="display: none; color: red;"></label>
                                </CCol>                                    
                            </CRow>
                            <CRow>
                                <CCol sm="4">
                                    <label class="form-label font-weight-bold">Status</label>
                                    <label class="form-label font-weight-bold" style="float:right">:&nbsp;</label>
                                </CCol>
                                <CCol sm="8">
                                    <CSelect id="ActiveFlag" class="font-weight-bold" :options="ActiveFlagData" :value.sync="ActiveFlag" />
                                    <label id="errorActiveFlag" class="form-error" style="display: none; color: red;"></label>
                                </CCol>                                    
                            </CRow>
                            <CRow>
                                <CCol sm="4">
                                    <label class="form-label font-weight-bold">Item Group</label>
                                    <label class="form-label font-weight-bold" style="float:right">:&nbsp;</label>
                                </CCol>
                                <CCol sm="8">
                                    <CSelect id="ItemGroupId" class="font-weight-bold" :options="ItemGroupData" :value.sync="ItemGroupId" />
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol sm="4">
                                    <label class="form-label font-weight-bold">Visible</label>
                                    <label class="form-label font-weight-bold" style="float:right">:&nbsp;</label>
                                </CCol>
                                <CCol sm="8">
                                    <input type="checkbox" v-model="IsVisible"/>
                                </CCol>
                            </CRow>
                            
                            <CRow class="p-3">
                                <div class="p-3 border rounded" style="width: 100%;">
                                    <label class="form-label font-weight-bold" style="margin-bottom: 0px"><h4>Role</h4></label>
                                    <div class="row float-right pr-3">
                                        <button class="add-button btn btn-primary float-right"
                                            @click="addFormClick()">
                                            <i class="fa fa-plus"></i> Add
                                        </button>
                                    </div>
                                    <hr>

                                    <div>
                                        <datasource ref="roleDataSource" :data="this.RoleGridData" :page-size="10" :schema-model-fields="this.RoleGridDataSchemaModel"/>

                                        <kendo-grid ref="gridRole"
                                            :data-source-ref="'roleDataSource'"
                                            :editable="false"
                                            :pageable="true"
                                            :resizable="false"
                                            :filterable="true"
                                            :sortable="true"
                                            >

                                            <kendo-grid-column  :field="'roleid'"
                                                                :title="'Id'"
                                                                :width="100"
                                                                :hidden="true"
                                                                :headerAttributes="{ style: 'text-align:center; font-weight:bold;' }"></kendo-grid-column>

                                            <kendo-grid-column  :field="'rname'"
                                                                :title="'Nama Role'"
                                                                :width="250"
                                                                :headerAttributes="{ style: 'text-align:center; font-weight:bold;' }"></kendo-grid-column>

                                            <kendo-grid-column  :command="{ text: 'Delete', click: deleteClick }"
                                                                :title="'Action'"
                                                                :width="100"
                                                                :headerAttributes="{ style: 'text-align:center; font-weight:bold;' }"
                                                                :attributes="{style: 'text-align:center;'}"></kendo-grid-column>

                                        </kendo-grid>
                                    </div>
                                </div>
                            </CRow>
                            <br>
                            <CButton type="button" @click="saveClick()" class="save-button" id="saveButton" color="success" style="float: right;">Save</CButton>
                            <label style="float: right;">&nbsp;&nbsp;</label>
                            <CButton type="button" color="secondary" style="float: right;" data-bs-dismiss="modal" aria-label="Close">Close</CButton>
                        </CCardBody> 
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { globalfunc } from '../../../../shared/GlobalFunction.js';
import { response } from '../../../../infrastructure/constant/response';
import { Grid, GridColumn} from '@progress/kendo-grid-vue-wrapper';
import { DataSource } from '@progress/kendo-datasource-vue-wrapper';
import GroupTypeServices from '../Script/GroupTypeServices.js';

export default {
    name: 'ItemGroupForm',
    props: ['reload', 'addRoleClick'],
    components: {
        'kendo-grid' : Grid,
        'kendo-grid-column': GridColumn,
        'datasource' : DataSource,
    },
    data: function () {
        return {
            ModalTitle : '',
            GroupTypeId: '',
            GroupTypeName: '',

            ActiveFlag: '',
            ActiveFlagData: [],

            ItemGroupId: '',
            ItemGroupData: [],

            IsVisible: false,
            
            RoleGridData: [],
            RoleGridDataSchemaModel: {
                roleid: { type: "string", editable: false},
                rname: { type: "string", editable: false},
            },

            Error: 0,
            SaveType: '',
        }
    },
    mounted(){

    },
    methods: {
        async addClick(){
            $(".form-error").css("display", "none");
            this.ModalTitle = 'Add Group Type: '
            
            this.GroupTypeName = '';
            
            this.ActiveFlagData = [ 
                {value: 'N', label: 'New'} 
            ];
            this.ActiveFlag = this.ActiveFlagData[0].value;

            this.ItemGroupData = await GroupTypeServices.getItemGroupQuery();
            this.ItemGroupId = this.ItemGroupData[0].value;
            
            this.IsVisible = false;
            this.RoleGridData = [];

            this.SaveType = 'Add';
            window.$('#GroupTypeModal').modal('show');
        },
        async editClick(GroupTypeData, View){
            $(".form-error").css("display", "none");
            $(".save-button").show();
            this.ModalTitle = 'Edit Group Type: '
            
            this.GroupTypeId = GroupTypeData.group_type_id;
            this.GroupTypeName = GroupTypeData.group_type_name;

            if(GroupTypeData.active_flag == "N") {
                GroupTypeData.active_flag = "A";
            }

            this.ActiveFlag = GroupTypeData.active_flag;
            this.ActiveFlagData = [ 
                {value: 'A', label: 'Active'},
                {value: 'I', label: 'Inactive'} 
            ];

            this.ItemGroupData = await GroupTypeServices.getItemGroupQuery();
            this.ItemGroupId = parseInt(GroupTypeData.item_group_id);
            
            this.IsVisible = GroupTypeData.is_visible;

            this.RoleGridData = globalfunc.objectToArrayConverter(GroupTypeData.roles, "GroupType-RoleData");
            
            this.SaveType = 'Edit';

            if(View){
                $(".save-button").hide();
                this.ModalTitle = 'View Group Type: ';
            }

            window.$('#GroupTypeModal').modal('show');
        },
        async inputValidation() {
            this.Error = 0;
            $(".form-error").css("display", "none");

            if(this.GroupTypeName == ''){
                this.errorShow('errorGroupTypeName');
            }

            var gridData = this.$refs.gridRole.kendoWidget().dataSource._data;
            if (gridData.length == 0) {
                this.$swal("Error", "Role Data Cannot be empty", "error");
            }
        },
        saveClick() {
            this.inputValidation();
            var GroupTypeRoleData = this.$refs.gridRole.kendoWidget().dataSource._data;

            if(this.Error == 0){
                var RoleIdArray = GroupTypeRoleData.map(x => Number(x.roleid));

                if(this.SaveType == 'Add'){
                    this.$loading(true);

                    const GroupTypeData = {
                        group_type_name : this.GroupTypeName,
                        active_flag: this.ActiveFlag,
                        item_group_id: this.ItemGroupId,
                        is_visible: this.IsVisible,
                        role_ids: RoleIdArray
                    };

                    const variables = {
                        data : GroupTypeData
                    }

                    GroupTypeServices.addQuery(variables).then(res => {
                        this.$loading(false);
                        window.$('#GroupTypeModal').modal('hide');
                        this.$swal("Info", response.successSave, "success");
                        this.$props.reload();
                    }).catch(error => {
                        this.$loading(false);
                        var errorMessage = this.$globalfunc.errorExtractor(error)
                        this.$swal("Error", errorMessage, "error");
                    })
                }
                else if(this.SaveType == 'Edit'){
                    this.$loading(true);

                    const GroupTypeData = {
                        group_type_name : this.GroupTypeName,
                        active_flag : this.ActiveFlag,
                        item_group_id : this.ItemGroupId,
                        is_visible: this.IsVisible,
                        role_ids: RoleIdArray
                    };

                    const variables = {
                        id : this.GroupTypeId.toString(),
                        data : GroupTypeData
                    }

                    GroupTypeServices.editQuery(variables).then(res => {
                        this.$loading(false);
                        window.$('#GroupTypeModal').modal('hide');
                        this.$swal("Info", response.successUpdate, "success");
                        this.$props.reload();
                    }).catch(error => {
                        this.$loading(false);
                        var errorMessage = this.$globalfunc.errorExtractor(error)
                        this.$swal("Error", errorMessage, "error");
                    })
                }
            }
        },
        errorShow(errorCode){
            document.getElementById(errorCode).style.display = 'block';
            document.getElementById(errorCode).innerHTML = response.fieldRequired;
            if(this.Error <= this.$globalvariable.max_error_focus){ document.getElementById(errorCode.replace("error", "")).focus(); }
            this.Error++;
        },
        
        addFormClick(){
            this.$props.addRoleClick();
        },
        groupTypeRoleGridData(data){
            var gridData = this.$refs.gridRole.kendoWidget().dataSource._data;
            var GroupTypeRoleData = GroupTypeServices.gridDataConverter(gridData);

            var inputData = GroupTypeServices.gridDataConverter(data);
            GroupTypeRoleData = GroupTypeRoleData.concat(inputData);

            this.RoleGridData = Object.values(GroupTypeRoleData.reduce((a, c) => (a[`${c.roleid}${c.rname}`] = c, a), {})); 
        },
        deleteClick: function(e) {
            e.preventDefault();
            var grid = this.$refs.gridRole.kendoWidget();
            var dataItem = grid.dataItem($(e.currentTarget).closest("tr"));
            console.log(dataItem)
            
            var gridItem = grid.dataSource._data;
            var itemData = this.$globalfunc.objectToArrayConverter(gridItem, "GroupType-RoleData");
            var index = itemData.findIndex((obj => obj.roleid == dataItem.roleid));

            itemData.splice(index, 1);
            this.RoleGridData = itemData;
        }
    },
}
</script>
